import { InjectionToken, Provider } from '@angular/core';

import { SystemHealthApi } from '../types/system-health-api.types';

import { SystemHealthApiService } from './system-health-api.service';

export const SYSTEM_HEALTH_API_TOKEN = new InjectionToken<SystemHealthApi>('SYSTEM_HEALTH_API_TOKEN');

/**
 * Binds the port to the HTTP implementation.
 *
 * @returns Provider for the application config.
 */
export function provideSystemHealthApi(): Provider {
  return {
    provide: SYSTEM_HEALTH_API_TOKEN,
    useExisting: SystemHealthApiService,
  };
}
